import { SessionHub } from '@addmile/backend-client';
import { AccessorKeyColumnDef } from '@tanstack/react-table';

export const getColumnOptions = (
  columns: AccessorKeyColumnDef<SessionHub>[],
  columnVisibility: Record<string, boolean>,
) => {
  return columns.map((column) => ({
    id: String(column.id ?? column.accessorKey),
    label:
      typeof column.header === 'string' ? column.header : String(column.accessorKey ?? column.id),
    checked: columnVisibility[String(column.id ?? column.accessorKey)] ?? false,
  }));
};
